<div class="dialog-molecule-root">
  <button
    id="close-dialog-icon"
    (click)="onFailClick()"
    mat-icon-button
    class="close-button"
  >
    <mat-icon>close</mat-icon>
  </button>

  <app-header *ngIf="data.title" id="dialog-modal-title">
    {{ data.title }}
  </app-header>
  <div mat-dialog-content>
    <app-paragraph
      *ngIf="data.content"
      id="dialog-modal-content"
      class="dialog-modal-content"
      [ngClass]="{ 'keep-white-space': contentKeepWhiteSpace }"
    >
      {{ data.content }}
    </app-paragraph>
  </div>
  <div *ngIf="data.secondaryContent">
    <p
      *ngFor="let item of data.secondaryContent"
      id="dialog-modal-sec-content"
      class="dialog-modal-sec-content"
      [ngClass]="{ 'keep-white-space': contentKeepWhiteSpace }"
      [ngStyle]="item.style"
      [innerHTML]="item.content"
    >
      {{ item.content }}
    </p>
  </div>
  <div mat-dialog-actions>
    <app-primary-button
      v2Outlined
      id="fail-dialog-btn"
      *ngIf="data.failButtonText"
      mat-button
      (click)="onFailClick()"
    >
      {{ data.failButtonText }}
    </app-primary-button>
    <app-primary-button
      v2Full
      class="success-button"
      id="success-dialog-btn"
      *ngIf="data.successButtonText"
      mat-button
      (click)="onSuccessClick()"
    >
      {{ data.successButtonText }}
    </app-primary-button>
    <app-icon-button
      id="success-dialog-btn"
      icon="delete"
      type="submit"
      v2Delete
      *ngIf="data.deleteButtonText"
      (clickAction)="onSuccessClick()"
    >
      {{ data.deleteButtonText }}
    </app-icon-button>
  </div>
</div>
